import TYPES from '../actions/types';

const INITIAL_STATE = {
  survey: null,
  clientProfile: null,

  getDetailError: false,
}

const detailsReducer = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case TYPES.detailsData:
      return {
        ...state,
        survey: action.payload.data.survey,
        clientProfile: action.payload.data.profile,
        getDetailError: false,
      };

    case TYPES.detailsError:
      return { ...state, getDetailError: true };

    case TYPES.clearResult:
      return { ...state, ...INITIAL_STATE };

    default:
      return state;
  }
}

export default detailsReducer;
